import React from 'react';
import {
  PRODUCT_WIDGET_LAYOUT_TYPE_V2,
  ProductWidgetCreatePayloadV2,
  ProductWidgetDetailV2,
  WIDGET_TYPE_V2,
} from '../../../../../types/widget';
import { getInitialPeriod } from '../../common/utils/getInitialPeriod';
import ProductWidgetForm from './ProductWidgetForm';
import { WIDGET_PRODUCT_RANDOM_ITEM_COUNT_SELECT_LIST_V2 } from '../../../../../constants/service/app/widgetConstantsV2';

export interface ProductWidgetFormWrapperProps {
  isEdit: boolean;
  initialValue?: ProductWidgetDetailV2;
  onChangeType: (type: WIDGET_TYPE_V2) => void;
  onFinish: (value: ProductWidgetCreatePayloadV2) => void;
}

const ProductWidgetFormWrapper = (props: ProductWidgetFormWrapperProps): JSX.Element => {
  const { isEdit, initialValue, onChangeType, onFinish } = props;

  const { exposurePeriod, exposureItemCount, ...restInitialValue } = initialValue || {};

  const randomCountSelectList =
    WIDGET_PRODUCT_RANDOM_ITEM_COUNT_SELECT_LIST_V2[
      initialValue?.layoutType || PRODUCT_WIDGET_LAYOUT_TYPE_V2.GRID_2X2
    ] || [];

  const exposureItemCountInitialValue =
    randomCountSelectList.length > 0 && randomCountSelectList[0].id ? randomCountSelectList[0].id : 0;

  const formInitialValue = {
    type: WIDGET_TYPE_V2.PRODUCT,
    layoutType: PRODUCT_WIDGET_LAYOUT_TYPE_V2.GRID_2X2,
    exposurePeriod: getInitialPeriod(exposurePeriod),
    exposureItemCount: exposureItemCount || exposureItemCountInitialValue,
    ...restInitialValue,
  };

  return (
    <ProductWidgetForm
      isEdit={isEdit}
      initialValue={formInitialValue}
      onChangeType={onChangeType}
      onFinish={onFinish}
    />
  );
};

export default ProductWidgetFormWrapper;
